import React, { FC } from 'react';
import styled from 'styled-components';

import Collapse from 'crehana-ui/Collapse';
import ArrowBottom from 'crehana-icons/ArrowBottom';
import { baseLighter } from 'crehana-ui/styles/colors';

import useDisclosure from 'Shared/Hooks/useDisclosure';

const Container = styled.section`
  padding: 16px;
  min-height: 50px;
  border: 1px solid #e8eaf0;
  background-color: #fff;
  margin-bottom: 16px;

  @media (min-width: 1024px) {
    padding: 24px;
    min-height: 72px;

    .font-subtitle4 {
      font-size: 16px;
      line-height: 20px;
    }
  }
`;

const WrapperArrowBottom = styled.div<{ isOpen }>`
  transition: 0.3s;
  transform: rotate(${({ isOpen }) => (isOpen ? '-180deg' : '0deg')});
`;

type QuestionProps = {
  title: string;
  titlePayTo?: string;
  text: string | JSX.Element[];
  textPayTo?: string;
  price: number;
};

const Question: FC<QuestionProps> = ({
  title,
  titlePayTo = null,
  price,
  text,
  textPayTo,
}) => {
  const { isOpen, onToggle } = useDisclosure();
  const isFree = price === 0;

  return (
    <Container className="flex flex-col">
      <button type="button" onClick={onToggle} className="flex justify-between">
        <h4 className="font-subtitle4 text-left">
          {isFree ? title : titlePayTo || title}
        </h4>
        <WrapperArrowBottom isOpen={isOpen}>
          <ArrowBottom color={baseLighter} size={14} />
        </WrapperArrowBottom>
      </button>
      <Collapse open={isOpen}>
        <p className="font-body3 text-gray-dark mt-12">
          {isFree ? text : textPayTo}
        </p>
      </Collapse>
    </Container>
  );
};

export default Question;
